import { render, staticRenderFns } from "./AppSend.vue?vue&type=template&id=798adef2&scoped=true"
import script from "./AppSend.vue?vue&type=script&lang=js"
export * from "./AppSend.vue?vue&type=script&lang=js"
import style0 from "./AppSend.vue?vue&type=style&index=0&id=798adef2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798adef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798adef2')) {
      api.createRecord('798adef2', component.options)
    } else {
      api.reload('798adef2', component.options)
    }
    module.hot.accept("./AppSend.vue?vue&type=template&id=798adef2&scoped=true", function () {
      api.rerender('798adef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/AppSend.vue"
export default component.exports